import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const imageSrc = require("../logo.jpeg");
const logout_logo = require("../download (1).png");

const Header = () => {
  const [preparation, setPreparation] = useState({});
  const [cmd, setCmd] = useState({});
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    checkValidLogin();
    getStoresHistoryDates();
  }, []);

  async function checkValidLogin() {
    let token = localStorage.getItem("amira-token");
    if (!token) {
      window.location.href = "/";
    }
  }

  async function logout() {
    localStorage.removeItem("amira-token");
    window.location.href = "/";
  }

  async function getStoresHistoryDates() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/file-history/data`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
          },
        }
      );
      console.log(response.data);
      const data = response.data;
      if (data.status === "Success") {
        setPreparation(data.data.preparation || {});
        setCmd(data.data.cmd || {});
      }
    } catch (err) {
      console.log(err);
    }
  }

  // exportPreparation moved to Dashboard.js

  return (
    <nav className="navbar navbar-expand-lg navbar-dark mx-5">
      <div className="container-fluid d-flex justify-content-start gap-4">
        <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/dashboard/"}
        >
          <img src={imageSrc} alt="logo" />
        </NavLink>
        <div className="history-date-containers text-bold">
          <div className="history-date">
            Preparation Commandes:{" "}
            {preparation.date
              ? new Date(preparation.createdAt).toLocaleDateString()
              : "-"}
          </div>
          <div className="history-date">
            CMD non soldées:{" "}
            {cmd.date ? new Date(cmd.createdAt).toLocaleDateString() : "-"}
          </div>
        </div>
      </div>

      <div className="d-flex mb-3">
        <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/dashboard/"}
        >
          <button className="btn btn-outline-primary"> Customers </button>
        </NavLink>
        <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/supplier-dashboard/"}
        >
          <button className="btn btn-outline-primary"> Suppliers </button>
        </NavLink>
        {/* <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/danielli-dashboard/"}
        >
          <button className="btn btn-outline-primary"> Danielli Activity </button>
        </NavLink> */}
        {/* <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/orders-stock/"}
        >
          <button className="btn btn-outline-primary"> Orders Stock </button>
        </NavLink> */}
        <NavLink
          className="navlink navbar-brand mt-2 mt-lg-0"
          to={"/orders-stock-print/"}
        >
          <button className="btn btn-outline-primary"> Print Orders </button>
        </NavLink>
        {/* Export button moved to Dashboard */}
      </div>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <div className="logout-box">
          <a href="#" className="button rounded-pill" onClick={logout}>
            <img src={logout_logo} alt="logout" />
            <div className="logout">LOGOUT</div>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
